import React from 'react';
import {withRouter} from "./withRouter";
import {NavLink} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";

class UpdateCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            company: null
        };

        console.log(JSON.stringify(props));
    }

    handleSubmit(e) {
        e.preventDefault();

        console.log(JSON.stringify(this.props));

        const { navigate } = this.props;

        const body = {
            'site': e.target.site.value,
            'description': e.target.description.value,
            'phone_number': e.target.phone_number.value,
            'team_members': [],
            'address': {
                'line1': e.target.address_line1.value,
                'postal_code': e.target.address_postal_code.value,
                'city': e.target.address_city.value,
                'state': e.target.address_city.value,
                'country': e.target.address_country.value,
            },
        };

        console.log(body);

        fetch(process.env.REACT_APP_API_URL + '/publisher/company/' + this.props.companyId, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
            (result) => {
                this.setState({
                    isLoaded: true
                });

                navigate('/account/company/' + result.id);
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        );
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/publisher/" + this.props.companyId.toString() + "/stats", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        company: result.company
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    hideOrShowCardForm(){
        let form = document.getElementById('card_data');

        if (form.style.visibility === 'hidden') {
            form.style.visibility = 'visible';
        } else {
            form.style.visibility = 'hidden';
        }
    }

    render() {
        const { error, isLoaded, company } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if(!isLoaded){
            content = <div>Loading...</div>;
        } else {
            content = (<div class="alert alert-light">
                <h3>Edit your company data:</h3>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <br/>
                    <label>Site: </label>
                    <input class="form-control" required type="url" name="site" defaultValue={company.site}/>
                    <br/>
                    <label>Description: </label>
                    <textarea class="form-control" name="description" defaultValue={company.description}/>
                    <br/>
                    <label>Your phone number: </label>
                    <input class="form-control" required type="text" name="phone_number" defaultValue={company.phone_number}/>
                    <br/>
                    <label>Country: </label>
                    <input class="form-control" required type="text" name="address_country" defaultValue={company.address ? company.address.country : ""}/>
                    <br/>
                    <label>State: </label>
                    <input class="form-control" required type="text" name="address_state" defaultValue={company.address ? company.address.state : ""}/>
                    <br/>
                    <label>City: </label>
                    <input class="form-control" required type="text" name="address_city" defaultValue={company.address ? company.address.city : ""}/>
                    <br/>
                    <label>Postal code: </label>
                    <input class="form-control" required type="text" name="address_postal_code" defaultValue={company.address ? company.address.postal_code : ""}/>
                    <br/>
                    <label>Address: </label>
                    <input class="form-control" required type="text" name="address_line1" defaultValue={company.address ? company.address.line1 : ""}/>
                    <br/>

                    <input class="btn btn-outline-warning" required type="submit" value="Save changes"/>
                </form>
            </div>);
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(UpdateCompany);
